import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
export default function createCSSStyleSheet(id) {
  if (canUseDOM) {
    var element = document.getElementById(id);

    if (element != null) {
      return element.sheet;
    } else {
      var _element = document.createElement('style');

      _element.setAttribute('id', id);

      var head = document.head;

      if (head) {
        head.insertBefore(_element, head.firstChild);
      }

      return _element.sheet;
    }
  } else {
    return null;
  }
}